import { render, staticRenderFns } from "./dashboardLinks.vue?vue&type=template&id=f55c222a&lang=pug&"
import script from "./dashboardLinks.vue?vue&type=script&setup=true&lang=js&"
export * from "./dashboardLinks.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports